import React, { FunctionComponent } from 'react';
import { I18n } from 'common/i18n';
import { ForgeIcon, ForgeIconButton, ForgeTooltip } from '@tylertech/forge-react';

interface MobileActionButtonProps {
  openActionsPage: () => void;
}

const MobileActionButton: FunctionComponent<MobileActionButtonProps> = ({ openActionsPage }) => {
  const scope = 'shared.site_chrome.forge_omnibar.navigation';

  return (
    <>
      <ForgeIconButton
        slot="profile"
        id="more-action-button"
        aria-label="View user profile"
        className="tyler-icons"
        onClick={openActionsPage}
      >
        <ForgeIcon name="more_vert" />
      </ForgeIconButton>
      <ForgeTooltip open placement={'bottom'}>
        {I18n.t(`${scope}.create`)}
      </ForgeTooltip>
    </>
  );
};

export default MobileActionButton;
